export default __webpack_public_path__ + "static/media/mail.9eae1384.jpg";